import React, { useContext, useState } from 'react';
import { RedocContext } from '../contexts';

export const Header = () => {
    const { specState, changeSpecState } = useContext(RedocContext);
    const [ api, setApi ] = useState(specState.api);
    const [ revision, setRevision ] = useState(specState.revision);

    const onSubmit = event => {
        event.preventDefault();
        changeSpecState({ api, revision });
    };

    const onApiChange = event => {
        setApi(event.target.value);

        changeSpecState({
            api: event.target.value
        });
    };

    return specState.isInternal &&
        <form className="header" onSubmit={onSubmit}>
            <label>Select Revision & API: </label>
            <input onChange={event => setRevision(event.target.value)} value={revision} className="version-input" />
            <select onChange={onApiChange} value={api} className="api-input">
                <option value="public">Partner API</option>
                <option value="v2">v2 API</option>
            </select>
            <button className="submit-button" type="submit">Select</button>
        </form>;
};
